module.exports = __webpack_public_path__ + "static/media/youtube-mobile-1.bfa845e9.svg";